import { Entity } from '@api';
import { ErrorBoundaryWrapper } from '@terminal/components/error-boundary-wrapper/ErrorBoundaryWrapper';
import { ErrorMessageWrapper } from '@terminal/components/error-message-wrapper/ErrorMessageWrapper';
import { BrandAndProductDrawer } from '@terminal/modules/brand-and-product-drawer/BrandAndProductDrawer';
import styles from './BrandsAndProductsTab.module.scss';
import { BrandsAndProductsTable } from './brands-and-products-table/BrandsAndProductsTable';

export interface BrandsAndProductsTabProps {
  entity: Entity;
}

export const BrandsAndProductsTab = ({ entity }: BrandsAndProductsTabProps) => {
  return (
    <div className={styles.root} data-testid="brands-and-products-tab">
      <ErrorBoundaryWrapper
        fallback={
          <ErrorMessageWrapper
            className={styles.styledErrorMessageWrapper}
            displayIcon
          />
        }
      >
        <BrandsAndProductsTable entity={entity} />
      </ErrorBoundaryWrapper>
      <BrandAndProductDrawer entity={entity} />
    </div>
  );
};
